import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import { uploadCourseCover } from '@/api/course';
import { saveGraphic, getGraphicInfo, getMediaGroups } from '@/api/material';
import { checkSession } from '@/api/commom';
import { UserModule } from "@/store/modules/user";
import WangEditor from "@/components/WangEditor/index.vue";
import eventEmitter from '@/utils/eventEmitter';
let timer = null;
const widthHeightVerify = (file) => {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.onload = function () {
            console.log(image.width);
            if (image.width !== 750 || image.height !== 560) {
                resolve(false);
            }
            else {
                resolve(true);
            }
        };
        image.src = window.URL.createObjectURL(file);
    });
};
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.form = {
            id: '',
            title: '',
            cover: '',
            details: '',
            relativeFile: [],
            groupId: '0',
            isCopy: 1,
            onlineNow: 1,
            delayedTime: "",
        };
        this.groups = [];
        this.isCoverLoading = false; // 课程封面加载状态
        this.isPrevent = false;
    }
    created() {
        this.initGroupData();
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id;
            this.getDetails();
        }
        else {
            this.form.groupId = this.$route.query.groupId;
        }
        eventEmitter.on('routerRapture', () => {
            return this.isPrevent ? Promise.resolve() : Promise.reject();
        });
        const t = 1 * 60 * 1000;
        timer = setInterval(() => {
            this.checkHeartbeat();
        }, t);
    }
    beforeDestroy() {
        clearInterval(timer);
    }
    async checkHeartbeat() {
        await checkSession();
    }
    // 获取分组列表
    async initGroupData() {
        const res = await getMediaGroups(3);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.groups = [
            // 默认置顶【全部图文】分组
            {
                name: "全部图文",
                value: '0',
            },
            ...data.map((group) => {
                return {
                    name: group.name,
                    value: group.id,
                };
            }),
        ];
    }
    async getDetails() {
        const res = await getGraphicInfo(this.form.id);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.form.id = res.data.data.id;
        this.form.title = res.data.data.title;
        this.form.cover = res.data.data.coverUrl;
        this.form.details = res.data.data.content;
        this.form.relativeFile = res.data.data.relativeFile || [];
        this.form.groupId = res.data.data.groupId;
        this.form.isCopy = res.data.data.isCopy;
        this.form.onlineNow = res.data.data.onlineNow;
        this.form.delayedTime = res.data.data.delayedTime;
        if (res.data.data.content) {
            this.wangEditor.setContent(res.data.data.content);
        }
    }
    // 选择课程封面
    handleCoverSelect(file) {
        return new Promise((resolve, reject) => {
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error("封面图片大小不能超过 5MB!");
                return reject(false);
            }
            const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            if (!(isJPG || isPNG)) {
                this.$message.error("封面图片只能是JPG/PNG格式!");
                return reject(false);
            }
            // return widthHeightVerify(file).then((data:any)=>{
            //     if(data){
            //         resolve(data);
            //     }else{
            //         this.$message.error("封面图片尺寸为750 * 560");
            //         reject(data);
            //     }
            // })
            return resolve(true);
        });
    }
    handleFileSelect(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
            this.$message.error("课件大小不能超过 20MB!");
            return false;
        }
        // const isPPT: boolean =
        // file.type === "application/vnd.ms-powerpoint" ||
        // file.type ===
        //     "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
            this.$message.error("课件资料只能是PDF格式!");
            return false;
        }
        return true;
    }
    // 上传课程封面
    async handleCoverUpload(data) {
        this.isCoverLoading = true;
        const file = data.file;
        try {
            const res = await uploadCourseCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverLoading = false;
            });
            if (res.data.status !== 200) {
                // 上传器公用 随手清理垃圾
                return this._coverUploader.clearFiles();
            }
            this.form.cover = res.data.data;
        }
        catch {
            this.isCoverLoading = false;
        }
    }
    // 上传课程封面
    async handleFileUpload(data) {
        const file = data.file;
        try {
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const res = await uploadCourseCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            loading.close();
            if (res.data.status !== 200) {
                // 上传器公用 随手清理垃圾
                return this._FileUploader.clearFiles();
            }
            let data = {
                fileUrl: res.data.data,
                fileName: file.name || ''
            };
            this.form.relativeFile.push(data);
            // console.log(file.name);
            // this.form.f = res.data.data as string;
        }
        catch {
            this.isCoverLoading = false;
        }
    }
    async onSave() {
        try {
            if (this.form.title === '') {
                return this.$message.error('名称不可为空');
            }
            if (this.form.cover === '') {
                return this.$message.error('封面图片不可为空');
            }
            if (this.form.details === '') {
                return this.$message.error('图文详情不可为空');
            }
            let data = {
                title: this.form.title,
                coverUrl: this.form.cover,
                content: this.form.details,
                relativeFile: this.form.relativeFile,
                isCopy: this.form.isCopy,
                onlineNow: this.form.onlineNow,
                delayedTime: this.form.delayedTime,
                groupId: this.form.groupId
            };
            if (this.form.id) {
                data.id = this.form.id;
            }
            const res = await saveGraphic(data);
            if (res.data.status !== 200) {
                throw new Error(res.data.msg || 'An error occurred while saving data');
            }
            this.$message({
                type: 'success',
                message: '保存成功'
            });
            this.isPrevent = true;
            this.$router.go(-1); // you might want to check if $router is accessible and valid.
        }
        catch (err) {
            console.error(err);
            this.$message.error(String(err));
        }
    }
    onPrivew(props) {
        window.open(props.fileUrl);
    }
    onDel(idx) {
        this.form.relativeFile.splice(idx, 1);
    }
};
tslib_1.__decorate([
    Ref()
], Login.prototype, "_coverUploader", void 0);
tslib_1.__decorate([
    Ref()
], Login.prototype, "_FileUploader", void 0);
tslib_1.__decorate([
    Ref()
], Login.prototype, "wangEditor", void 0);
Login = tslib_1.__decorate([
    Component({
        components: {
            WangEditor
        },
    })
], Login);
export default Login;
